import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { getMassivelyAssignData, setMassivelyAssign } from '../../../../../../../redux/actions/users'
import IFamily from '../../../../../brands/models/FamilyInterface'

type IFilter = {
  family: IFamily | null
  brands: number[]
}

export type MassivelyAssign = {
  brands: BrandVip[]
  lines: LineVip[]
  menus: number[]
}

export type BrandVip = {
  brand_id: number
  type: number
  status: number
}

export type LineVip = {
  line_id: number
  type: number
  status: number
}

export function useMassiveAssignState(userIds: number[], open: boolean) {
  const dispatch = useDispatch()

  const [massivelyAssign, setMassivelyAssignState] = useState<MassivelyAssign>({
    brands: [],
    lines: [],
    menus: []
  })

  const [filters, setFilters] = useState<IFilter>({
    family: null,
    brands: []
  })

  useEffect(() => {
    clearModal()
  }, [])

  useEffect(() => {
    if (open) dispatch(getMassivelyAssignData(userIds))
  }, [open])

  const handleInputChange = (inputName: string, value: any) => {
    setFilters({ ...filters, [inputName]: value })
  }

  const clearModal = () => {
    setMassivelyAssign({
      brands: [],
      lines: [],
      menus: []
    })
    setFilters({ family: null, brands: [] })
    // setTmpBrands([])
  }

  return { massivelyAssign, filters, handleInputChange, setMassivelyAssignState, clearModal }
}
